import { useTenant } from "features/shell";
import React from "react";
import AccessDenied from "./AccessDenied";

interface RestrictedMakerRealmProps {
  children?: React.ReactNode;
  silent?: boolean;
}

const RestrictedMakerRealm: React.FC<RestrictedMakerRealmProps> = ({
  children,
  silent
}) => {
  const { makerFeaturesEnabled } = useTenant();
  return makerFeaturesEnabled ? (
    <>{children}</>
  ) : silent ? null : (
    <AccessDenied missingPermissions={["Maker tenant"]} />
  );
};

export default RestrictedMakerRealm;
